export class Setting {
  id: number;
  intranet_id: number;
  setting_type_id: number;
  value: string;
}
